'use client';
import React, { FC } from 'react';
import styles from './Overlay.module.scss';
// import { Mode, Store } from '@/src/app/(root)/find-a-dealer/MapSection/Types/types';
import SearchSection from './SearchSection';
import InfoSection from './InfoSection';
import ContactSection from './ContactSection';
import ThankYouSection from './ThankYouSection';
import { useMediaQuery } from 'usehooks-ts';
import InfoSectionMobile from './InfoSectionMobile';

// type OverlayProps = {
//   mode: Mode;
//   postcode: string;
//   onChangePostcode: (value: string) => void;
//   onSearch: () => void;
//   onBack: () => void;
//   onStart: () => void;
//   onContact: () => void;
//   selectedStore: Store | null | undefined;
//   fetchLocations: (inputText: string) => void;
//   setMode: React.Dispatch<React.SetStateAction<Mode>>;
//   mobile: boolean;
// };

const Overlay = ({
  mode,
  postcode,
  onChangePostcode,
  onSearch,
  onBack,
  onStart,
  onContact,
  selectedStore,
  fetchLocations,
  setMode,
  mobile,
  fields, // 新增：fields 参数
  postcodeError,
}) => {
  return (
    <div className={styles.overlay}>
      {/* 隐藏搜索框 */}
      {mode === 'SEARCH' && (
        <SearchSection
          postcode={postcode}
          onChangePostcode={onChangePostcode}
          onSearch={onSearch}
          onStart={onStart}
          fetchLocations={fetchLocations}
          postcodeError={postcodeError}
          fields={fields}
        />
      )}
      {mode === 'INFO' && selectedStore && !mobile && (
        <InfoSection
          selectedStore={selectedStore}
          onStart={onStart}
          onContact={onContact}
          fields={fields} // 传递 fields 参数
        />
      )}
      {/* 隐藏移动端搜索框 */}
      {/* {mode === 'INFO' && selectedStore && mobile && (
        <SearchSection
          postcode={postcode}
          onChangePostcode={onChangePostcode}
          onSearch={onSearch}
          onStart={onStart}
          fetchLocations={fetchLocations}
        />
      )} */}
      {mode === 'CONTACT' && selectedStore && (
        <ContactSection
          selectedStore={selectedStore}
          onBack={onBack}
          setMode={setMode}
          onStart={onStart}
        />
      )}
      {mode === 'THANKS' && <ThankYouSection onBack={onBack} onStart={onStart} />}
    </div>
  );
};

export default Overlay;
